import { IPageParam } from '@core/main/types';

/**
 * 失败类型
 */
export enum ERiskIssueAlarmStatus {
  /** 手机号黑名单 */
  PHONE_BLACKLIST = 'PHONE',
  /** 身份证黑名单 */
  ID_BLACKLIST = 'ID_NO',
  /** 董监高 */
  DONG_JIAN_GAO = 'SENIOR_EXECUTIVE',
}

export const riskIssueAlarmStatusLabel = {
  [ERiskIssueAlarmStatus.PHONE_BLACKLIST]: '手机号黑名单',
  [ERiskIssueAlarmStatus.ID_BLACKLIST]: '身份证黑名单',
  [ERiskIssueAlarmStatus.DONG_JIAN_GAO]: '董监高',
};

export const riskIssueAlarmStatusStyle = {
  [ERiskIssueAlarmStatus.PHONE_BLACKLIST]: 'primary',
  [ERiskIssueAlarmStatus.ID_BLACKLIST]: 'success',
  [ERiskIssueAlarmStatus.DONG_JIAN_GAO]: 'info',
};

/**
 * 预警类型
 */
export enum ERiskIssueAlarmType {
  /** 董监高发放 */
  DONG_JIAN_GAO_ISSUE = 'SENIOR_EXECUTIVE',
  /** 黑名单发放 */
  BLACKLIST_LOGIN = 'DISTRIBUTE_DENY',
}

export const riskIssueAlarmTypeLabel = {
  [ERiskIssueAlarmType.DONG_JIAN_GAO_ISSUE]: '董监高发放',
  [ERiskIssueAlarmType.BLACKLIST_LOGIN]: '黑名单发放',
};

export interface IRiskIssueAlarmItem {
  /** 预警ID */
  alertId?: string;
  /** 姓名 */
  personName?: string;
  /** 手机号 */
  phoneNumber?: string;
  /** 身份证号 */
  personIdNumber?: string;
  /** 预警类型 */
  warningType?: ERiskIssueAlarmType;
  /** 失败类型 */
  alertType?: ERiskIssueAlarmStatus;
  /** 企业名称 */
  companyName?: string;
  /** 统一社会信用代码 */
  creditCode?: string;
  /** 发放时间 */
  firstReleaseTime?: string;
  /** 导表金额（¥） */
  settlementAmount?: number;
}

export interface IRiskIssueAlarmParams extends IPageParam, IRiskIssueAlarmItem {
  /** 开始时间 */
  firstReleaseTimeStart?: string;
  /** 结束时间 */
  firstReleaseTimeEnd?: string;
}